module.exports = __webpack_public_path__ + "img/logo_app_cor.ba26da56.svg";